/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */
export { platformBrowserTesting, BrowserTestingModule } from './public_api';
export { createNgZone as ɵa } from './src/browser_util';
//# sourceMappingURL=testing.js.map